import { render } from "./PrimaryModal.vue?vue&type=template&id=3e44d44a"
import script from "./PrimaryModal.vue?vue&type=script&lang=js"
export * from "./PrimaryModal.vue?vue&type=script&lang=js"

import "./PrimaryModal.vue?vue&type=style&index=0&id=3e44d44a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__